<template>
  <v-container>
    <!-- If we're editing a user -->
    <EditUser
      :userData="editUser"
      @saved="userUpdateSuccessful"
      @disabled="cancelEdit"
      v-if="isEditMode"
    />

    <!-- If we are not, everything else can happen -->
    <v-layout row wrap class="mb-5" v-else>
      <v-flex xs12>
        <v-layout align-center>
          <h1 class="primary--text mr-3">Partner Staff</h1>
          <v-btn
            small
            depressed
            color="accent"
            :to="`/users/create?next=/users/agents/agency`"
            v-if="$can('create_user')"
          >
            <v-icon small>add</v-icon>Create Staff
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line></v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <app-alert
      class="mb-3"
      type="success"
      message="User successfully created."
      v-if="$route.query.userCreated && !isEditMode"
    />

    <app-alert class="mb-3" type="success" :message="userUpdated" :dismissible="true"/>

    <!-- Partner Staff List -->
    <v-layout row wrap class="mt-4" v-if="!isEditMode && $can('view_agency_agents')">
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">
            <span v-if="currentUser.role === roles.admin">Partner Staff</span>
            <span v-else>{{ agencyName(currentUser.parent_id) }} Staff</span>
            <span v-if="search !== ''">&nbsp;(Results for "{{ search }}")</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="agentHeaders"
            :items="agencyAgents"
            :loading="agentsLoading"
            :search="search"
            :rows-per-page-items="[30, 60, 100]"
            no-data-text="No Partner Staff available"
            :hide-actions="agencyAgents.length < 5"
          >
            <template v-slot:items="props">
              <td> {{ (props.index + 1) }} </td>
              <td class="py-3">{{ props.item.name }}</td>
              <td class="py-3">{{ props.item.email }}</td>
              <td>{{ agencyName(props.item.parent_id) }}</td>
              <td>{{ $lang(props.item.role) }}</td>

              <td>
                <v-chip
                  small
                  :color="props.item.status === 'active' ? 'green' : 'red'"
                  text-color="white"
                  style="text-transform: capitalize"
                >{{ props.item.status }}</v-chip>
              </td>
              <td>
                <v-icon
                  small
                  class="mr-2"
                  @click="enableEditMode(props.item)"
                  v-if="currentUser._id !== props.item._id"
                >edit</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { USER_FETCH } from '@/store/actions/user'
import { STATE_FETCH } from '@/store/actions/state'
import { AGENCY_FETCH } from '@/store/actions/agency'
import rolesData from '@/data/roles'

import EditUser from './components/EditUser.vue'
import editUserMixin from './mixins/editUser'

export default {
  name: 'AgencyAgents',
  components: {
    EditUser
	},
	mixins: [editUserMixin],
  created () {
    if (this.$can('view_agents')) {
      this.fetchUsers(false, 'agentsLoading')
      this.$store.dispatch(STATE_FETCH)
        .finally(() => (this.statesLoading = false))
      this.$store.dispatch(AGENCY_FETCH)
        .finally(() => (this.agenciesLoading = false))
    }
  },
  data () {
    return {
      search: this.$route.query.s || '',
      roles: rolesData,
      statesLoading: true,
			agenciesLoading: true,
			
      agentsLoading: false,
      agentHeaders: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Partner', value: 'parent_id' },
        { text: 'Role', value: 'role' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    stateAgents () {
      return this.agents('state')
    },
    agencyAgents () {
      return this.agents('agency')
    },
    ...mapGetters(['currentUser'])
  },
  methods: {
    fetchUsers (isAdmin, loader, filter) {
      this[loader] = true
      this.$store.dispatch(USER_FETCH, { isAdmin, filter })
        .finally(() => (this[loader] = false))
    },
    agents (type) {
      if (this.currentUser.role === rolesData.admin) {
        return this.$store.getters.agentsByParent(type)
      }
      else {
        return this.$store.getters.agentsByParent(this.currentUser.parent_id)
      }
    },
    stateName (id) {
      return this.$store.getters.stateName(id)
    },
    agencyName (id) {
      return this.$store.getters.agencyName(id)
    }
  }
}
</script>
